import {getDevCenterDataStore} from '../../app/store';
const initialState = {};

const configurationReducerData = state => state.configurationReducer;
const apiHostURL = state => state.configurationReducer.apiHostURL;
const apiProdURL = state => state.configurationReducer.apiProdURL;
const signUpURL = state => state.configurationReducer.signUpURL;
const partnerName = state => state.configurationReducer.partnerName;
const partnerFullName = state => state.configurationReducer.partnerFullName;
const hostname = state => state.configurationReducer.hostname;
const merchantId = state => state.configurationReducer.merchantId;
const processorMap = state => state.configurationReducer.processorMap;
const processor = state => state.configurationReducer.processor;
const defaultMerchant = state => state.configurationReducer.defaultMerchant;
const authentication = state => state.configurationReducer.authentication;
const httpSignature = state => state.configurationReducer.httpSignature;
const keyId = state => state.configurationReducer.keyId;
const secretKey = state => state.configurationReducer.secretKey;
const jwt = state => state.configurationReducer.jwt;
const p12Key = state => state.configurationReducer.p12Key;
const headerParamDefaults = state => state.configurationReducer.headerParamDefaults;
const allConfigurationData = state => state.configurationReducer.allConfigurationData;
const currentAuthType = state => state.configurationReducer.currentAuthType;
const successStatus = state => state.configurationReducer.successStatus;
const successMessage = state => state.configurationReducer.successMessage;
const loaderCloseFlag = state => state.configurationReducer.loaderCloseFlag;
const isWidget = state => state.configurationReducer.isWidget;
const widgetExampleKey = state => state.configurationReducer.widgetExampleKey;
const deepLinkFlag = state => state.configurationReducer.deepLinkFlag;
const currentHTTPMerchantId = state => state.configurationReducer.currentHTTPMerchantId;
const currentJWTMerchantId = state => state.configurationReducer.currentJWTMerchantId;

const currentJWTMerchantKey = state => state.configurationReducer.currentJWTMerchantKey;
const currentKeyId = state => state.configurationReducer.currentKeyId;
const currentSecretKey = state => state.configurationReducer.currentSecretKey;
const currentP12Key = state => state.configurationReducer.currentP12Key;

function configurationReducer(state=initialState, action){
    if(action.type != undefined)
    {
    switch(action.type){
        case 'UPDATE_API_HOST_URL':
            return {
                ...state,
                apiHostURL: action.apiHostURL
            }
        case 'UPDATE_API_PROD_URL':
                return {
                    ...state,
                    apiProdURL: action.apiProdURL
            }
        case 'UPDATE_SIGN_UP_URL':
            return {
                ...state,
                signUpURL: action.signUpURL
            }    
        case 'UPDATE_HOSTNAME':
            return {
                ...state,
                hostname: action.hostname
            }
            
        case 'UPDATE_PARTNER_NAME': 
            return {
                ...state,
                partnerName: action.partnerName
            }

        case 'UPDATE_PARTNER_FULL_NAME': 
            return {
                ...state,
                partnerFullName: action.partnerFullName
            }
            
        case 'UPDATE_MERCHANT_ID':
            return {
                ...state,
                merchantId: action.merchantId
            }
        case 'UPDATE_PROCESSOR_MAP':
            return {
                ...state,
                processorMap: action.processorMap
            }    
        case 'UPDATE_PROCESSOR':
            return {
                ...state,
                processor: action.processor
            }
        case 'UPDATE_DEFAULT_MERCHANT':
            return {
                ...state,
                defaultMerchant: action.defaultMerchant
            }
        case 'UPDATE_AUTHENTICATION':
            return {
                ...state,
                authentication: action.authentication
            }
        case 'UPDATE_HTTP_SIGNATURE':
            return {
                ...state,
                httpSignature: action.httpSignature
            }
        case 'UPDATE_KEY_ID':
            return {
                ...state,
                keyId: action.keyId
            }
        case 'UPDATE_SECRET_KEY':
            return {
                ...state,
                secretKey: action.secretKey
            }
        case 'UPDATE_JWT':
            return {
                ...state,
                jwt: action.jwt
            }
        case 'UPDATE_P12KEY':
            return {
                ...state,
                p12Key: action.p12Key
            }
        case 'UPDATE_HEADER_PARAM_DEFAULTS':
            return {
                ...state,
                headerParamDefaults: action.headerParamDefaults
            }
        case 'UPDATE_ALL_CONFIGURATION_DATA':
            return {
                ...state,
                allConfigurationData: action.allConfigurationData
            }
        case 'UPDATE_CURRENT_AUTH_TYPE': 
            return {
                ...state,
                currentAuthType: action.currentAuthType
            }
        case 'UPDATE_SUCCESS_STATUS':
            return {
                ...state,
                successStatus: action.successStatus
            }
        case 'UPDATE_SUCCESS_MESSAGE':
            return {
                ...state,
                successMessage: action.successMessage
            }
        case 'UPDATE_LOADER_CLOSE_FLAG':
            return {
                ...state,
                loaderCloseFlag: action.loaderCloseFlag
            }
        case 'UPDATE_IS_WIDGET':
            return {
                ...state,
                isWidget: action.isWidget
            }
        case 'UPDATE_WIDGET_EXAMPLE_KEY':
            return {
                ...state,
                widgetExampleKey: action.widgetExampleKey
            }
        case 'UPDATE_DEEPLINK_FLAG':
            return {
                ...state,
                deepLinkFlag: action.deepLinkFlag
            }
        case 'UPDATE_CURRENT_HTTP_MERCHANT_ID':
            return {
                ...state,
                currentHTTPMerchantId: action.currentHTTPMerchantId
            }
        case 'UPDATE_CURRENT_JWT_MERCHANT_ID':
            return {
                ...state,
                currentJWTMerchantId: action.currentJWTMerchantId
            }
        case 'UPDATE_CURRENT_JWT_MERCHANT_KEY':
            return {
                ...state,
                currentJWTMerchantKey: action.currentJWTMerchantKey
            }
        case 'UPDATE_CURRENT_KEY_ID':
            return {
                ...state,
                currentKeyId: action.currentKeyId
            }
        case 'UPDATE_CURRENT_SECRET_KEY':
            return {
                ...state,
                currentSecretKey: action.currentSecretKey
            }
        case 'UPDATE_CURRENT_P12_KEY':
            return {
                ...state,
                currentP12Key: action.currentP12Key
            }
        default:
            return state;
    }
}
}

function getConfigurationReducerData(){
    return configurationReducerData(getDevCenterDataStore().getState())
}

function getApiHostURL(){
    return apiHostURL(getDevCenterDataStore().getState())
}

function getApiProdURL(){
    return apiProdURL(getDevCenterDataStore().getState())
}

function getSignUpURL(){
    return signUpURL(getDevCenterDataStore().getState());
}

function getHostname(){
    return hostname(getDevCenterDataStore().getState())
}

function getPartnerName(){
    return partnerName(getDevCenterDataStore().getState())
} 

function getPartnerFullName(){
    return partnerFullName(getDevCenterDataStore().getState())
}

function getMerchantId(){
    return merchantId(getDevCenterDataStore().getState())
}

function getProcessor(){
    return processor(getDevCenterDataStore().getState())
}

function getProcessorMap(){
    return processorMap(getDevCenterDataStore().getState())
}

function getDefaultMerchant(){
    return defaultMerchant(getDevCenterDataStore().getState())
}

function getAuthentication(){
    return authentication(getDevCenterDataStore().getState())
}

function getHttpSignature(){
    return httpSignature(getDevCenterDataStore().getState())
}

function getKeyId(){
    return keyId(getDevCenterDataStore().getState())
}

function getSecretKey(){
    return secretKey(getDevCenterDataStore().getState())
}

function getJwt(){
    return jwt(getDevCenterDataStore().getState())
}

function getP12Key(){
    return p12Key(getDevCenterDataStore().getState())
}

function getHeaderParamDefaults(){
    return headerParamDefaults(getDevCenterDataStore().getState())
}

function getAllConfigurationData(){
    return allConfigurationData(getDevCenterDataStore().getState());
}

function getCurrentAuthType(){
    return currentAuthType(getDevCenterDataStore().getState());
}

function getSuccessStatus(){
    return successStatus(getDevCenterDataStore().getState());
}

function getSuccessMessage(){
    return successMessage(getDevCenterDataStore().getState());
}

function getLoaderCloseFlag(){
    return loaderCloseFlag(getDevCenterDataStore().getState());
}

function getIsWidget(){
    return isWidget(getDevCenterDataStore().getState());
}

function getWidgetExampleKey(){
    return widgetExampleKey(getDevCenterDataStore().getState());
}

function getDeepLinkFlag(){
    return deepLinkFlag(getDevCenterDataStore().getState());
}
function getCurrentHTTPMerchantId(){
    return currentHTTPMerchantId(getDevCenterDataStore().getState());
}
function getCurrentJWTMerchantId(){
    return currentJWTMerchantId(getDevCenterDataStore().getState());
}
function getCurrentJWTMerchantKey(){
    return currentJWTMerchantKey(getDevCenterDataStore().getState());
}
function getCurrentKeyId(){
    return currentKeyId(getDevCenterDataStore().getState());
}
function getCurrentSecretKey(){
    return currentSecretKey(getDevCenterDataStore().getState());
}
function getCurrentP12Key(){
    return currentP12Key(getDevCenterDataStore().getState());
}
export default configurationReducer;
export {getConfigurationReducerData, getHostname, getPartnerName,getPartnerFullName, getMerchantId, getProcessor, getDefaultMerchant, getAuthentication, getHttpSignature, getKeyId, getSecretKey, getJwt, getP12Key, getHeaderParamDefaults, getAllConfigurationData,getProcessorMap, getCurrentAuthType, getSuccessStatus, getSuccessMessage, getLoaderCloseFlag, getDeepLinkFlag,getCurrentHTTPMerchantId,getCurrentJWTMerchantId, getCurrentJWTMerchantKey, getCurrentKeyId,getCurrentP12Key,getCurrentSecretKey,getApiHostURL,getApiProdURL,getSignUpURL,getIsWidget, getWidgetExampleKey};
